import { Controller } from "stimulus";

/**
 * Redirects after sign-up confirmation. When analytics is loaded, the
 * redirect waits for the GTM pageView callback (see src/analytics.js) so the
 * confirmation page view is recorded first.
 */
export default class PostSignupRedirectController extends Controller {
  connect() {
    const location = this.data.get("location");

    if (window.dataLayer === undefined || window.Turbolinks === undefined) {
      window.location.href = location;
    } else {
      window.gtmCallback = function () {
        window.Turbolinks.visit(location, { action: "replace" });
      };
    }
  }
}
